function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M22.46,35.225H12.709a8.815,8.815,0,0,1-8.765-8.875,8.678,8.678,0,0,1,8.765-8.875c.876,0,1.863.219,2.958.329l1.863.548.548-1.863c1.753-5.7,7.231-9.2,13.476-9.2A13.146,13.146,0,0,1,44.92,20.653a13.776,13.776,0,0,1-.548,3.616l-.767,2.739,2.958-.329h.548a3.965,3.965,0,0,1,.548,7.888H37.908a12.085,12.085,0,0,0-3.616-7.012A12.956,12.956,0,0,0,25.2,23.721a12.506,12.506,0,0,0-6.683,1.863L20.6,28.871a9.279,9.279,0,0,1,4.821-1.205A8.143,8.143,0,0,1,31.773,30.4a8.885,8.885,0,0,1,2.739,6.355,8.143,8.143,0,0,1-2.739,6.355A8.572,8.572,0,0,1,20.6,44.319l-2.082,3.287A14.016,14.016,0,0,0,25.2,49.687a12.4,12.4,0,0,0,9.094-3.725,12.887,12.887,0,0,0,3.616-7.669H48.1A7.7,7.7,0,0,0,55,30.4c0-3.287-3.068-6.355-6.683-7.012a5.467,5.467,0,0,0,.219-2.082C48.536,11.669,41.743,4,30.9,4h0A16.481,16.481,0,0,0,15.339,14.3c-.876,0-1.534-.329-2.52-.329a12.385,12.385,0,1,0-.329,24.761H23.227Z",
  transform: "translate(0 -4)",
  fill: "#1590cf"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 6.135,
  cy: 6.135,
  r: 6.135,
  transform: "translate(18.845 26.514)",
  fill: "#19457a"
});

var SvgApiManagementServices = function SvgApiManagementServices(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 45.687,
    viewBox: "0 0 55 45.687",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgApiManagementServices, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/api_management_services.906802ca.svg";
export { ForwardRef as ReactComponent };